export const GRID = 'GRID';
export const LIST = 'LIST';



/** WEBPACK FOOTER **
 ** ./src/show-page/constants/clip-layout.js
 **/